"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSaveShiftMiddleware = exports.isSaveCycleFunction = exports.isSaveTemplateFunction = exports.isSaveShiftTemplateFunction = exports.isSaveLiveFunction = void 0;
const ac_1 = require("@app/ac");
const create_template_shift_1 = __importDefault(require("@app/ac/create-template-shift"));
const edit_template_shift_1 = __importDefault(require("@app/ac/edit-template-shift"));
const set_cycle_detail_1 = __importDefault(require("@app/ac/set-cycle-detail"));
const set_cycle_detail_last_saved_1 = __importDefault(require("@app/ac/set-cycle-detail-last-saved"));
const create_shift_1 = require("@app/ac/shift-1.5/create-shift");
const create_shift_template_1 = require("@app/ac/shift-1.5/create-shift-template");
const update_shift_template_1 = require("@app/ac/shift-1.5/update-shift-template");
const update_cycle_detail_1 = __importDefault(require("@app/ac/update-cycle-detail"));
const ui_1 = require("@app/component/ui");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const shift_context_1 = require("../../shift-context");
const recoverAfterError = async (dispatch) => {
    await dispatch((0, ac_1.isLoading)(shift_context_1.SAVING_SHIFT_ACTION, true));
    await dispatch((0, ac_1.isLoading)('create-shift', true));
    await dispatch((0, ac_1.isLoading)('create-shift-template', true));
    await dispatch((0, ac_1.isLoading)('update-shift-template', true));
};
const saveLiveShift = (initialData, dispatch) => {
    const id = initialData?.shiftId;
    return async ({ data: { position, ...shift }, extra: { runAfterSubmit, copiesCount }, updateVariant = 'default', }) => {
        await dispatch((0, ac_1.isLoading)(shift_context_1.SAVING_SHIFT_ACTION));
        if ((0, util_1.isDefined)(id)) {
            let updateData = { ...shift, positionId: position };
            if (updateVariant === 'transferSlave') {
                // @ts-expect-error
                updateData = {
                    // a few selected fields that can be edited on transferSlave
                    contractId: shift.contractId,
                    customAttributes: shift.customAttributes,
                };
            }
            else if (updateVariant === 'transferMaster') {
                const { localityId, customAttributes, contractId, contractType, positionId, user, ...canUpdate } = updateData;
                // @ts-expect-error
                updateData = canUpdate;
            }
            const res = await dispatch((0, ac_1.updateLiveShift)(id, 
            // @ts-expect-error type differences between our form and ac
            updateData, undefined, undefined));
            if (runAfterSubmit) {
                await initialData?.afterSubmit?.(res);
            }
            await dispatch((0, ac_1.isLoading)(shift_context_1.SAVING_SHIFT_ACTION, true));
            return res;
        }
        try {
            const res = await dispatch((0, create_shift_1.createShift)({ form: { ...shift, position }, copiesCount }));
            await dispatch((0, ac_1.isLoading)(shift_context_1.SAVING_SHIFT_ACTION, true));
            if (runAfterSubmit) {
                await initialData?.afterSubmit?.(res);
            }
            else if (initialData?.isOffersOrUnassigned === 'offers') {
                await initialData?.afterSubmit?.(res);
            }
            return res;
        }
        catch (error) {
            await recoverAfterError(dispatch);
        }
    };
};
const saveShiftTemplate = (initialData, dispatch) => {
    return async ({ data, extra: { shiftTemplateName: templateName, shiftTemplateId: templateId }, }) => {
        await dispatch((0, ac_1.isLoading)(shift_context_1.SAVING_SHIFT_ACTION));
        if ((0, util_1.isDefined)(templateId)) {
            try {
                await dispatch((0, update_shift_template_1.updateShiftTemplate)({ data, templateId, templateName }));
                await dispatch((0, ac_1.isLoading)(shift_context_1.SAVING_SHIFT_ACTION, true));
                await initialData?.afterSubmit?.(undefined);
                return undefined;
            }
            catch (error) {
                await recoverAfterError(dispatch);
                return undefined;
            }
        }
        try {
            await dispatch((0, create_shift_template_1.createShiftTemplate)({ data, templateName }));
            await dispatch((0, ac_1.isLoading)(shift_context_1.SAVING_SHIFT_ACTION, true));
            await initialData?.afterSubmit?.(undefined);
            return undefined;
        }
        catch (error) {
            await recoverAfterError(dispatch);
            return undefined;
        }
    };
};
const saveTemplate = (initialData, dispatch) => {
    return async ({ data, extra }) => {
        await dispatch((0, ac_1.isLoading)(shift_context_1.SAVING_SHIFT_ACTION));
        const shiftId = initialData?.shiftId;
        const start = data.period.start.get('hours') * 60 + data.period.start.get('minutes');
        const end = data.period.end.get('hours') * 60 + data.period.end.get('minutes');
        const duration = end - start;
        const position = data.position;
        const requirementsArrayIndex = initialData?.templateAddToRequirementsArrayIdx;
        if (!(0, util_1.isDefined)(position)) {
            await dispatch((0, ac_1.isLoading)(shift_context_1.SAVING_SHIFT_ACTION, true));
            return undefined;
        }
        if (!(0, util_1.isDefined)(requirementsArrayIndex) && !(0, util_1.isDefined)(shiftId)) {
            await dispatch((0, ac_1.isLoading)(shift_context_1.SAVING_SHIFT_ACTION, true));
            return undefined;
        }
        const requirementInputData = {
            duration: duration <= 0 ? duration + 1440 : duration,
            positionId: position,
            start,
            locality: data.localityId,
            idealSkill: data.idealSkill,
            pauses: data.pauses,
            pausesFixed: data.pausesFixed,
            agenda: data.agenda,
            requirementsArrayIndex,
            copies: extra.copiesCount,
            note: data.note,
        };
        if ((0, util_1.isDefined)(shiftId)) {
            try {
                await dispatch((0, edit_template_shift_1.default)(initialData?.templateId, shiftId, requirementInputData));
                await dispatch((0, ac_1.isLoading)(shift_context_1.SAVING_SHIFT_ACTION, true));
                await initialData?.afterSubmit?.(undefined);
                return undefined;
            }
            catch (error) {
                await recoverAfterError(dispatch);
                return undefined;
            }
        }
        try {
            await dispatch((0, create_template_shift_1.default)(initialData?.templateId, requirementInputData));
            await dispatch((0, ac_1.isLoading)(shift_context_1.SAVING_SHIFT_ACTION, true));
            await initialData?.afterSubmit?.(undefined);
        }
        catch (error) {
            await recoverAfterError(dispatch);
        }
        return undefined;
    };
};
const saveCycle = (initialData, dispatch) => {
    return async ({ data }) => {
        await dispatch((0, ac_1.isLoading)(shift_context_1.SAVING_SHIFT_ACTION));
        if ((0, util_1.isUndefined)(initialData)) {
            await dispatch((0, ac_1.isLoading)(shift_context_1.SAVING_SHIFT_ACTION, true));
            return;
        }
        const cycleData = initialData.cycle;
        if ((0, util_1.isUndefined)(cycleData)) {
            await dispatch((0, ac_1.isLoading)(shift_context_1.SAVING_SHIFT_ACTION, true));
            return;
        }
        const colId = cycleData.colId;
        const groupId = cycleData.groupId;
        const eventId = cycleData.eventId;
        const id = `${groupId}_${colId}_${eventId}`;
        const start = data.period.start.get('hours') * 60 + data.period.start.get('minutes');
        const end = data.period.end.get('hours') * 60 + data.period.end.get('minutes');
        const shiftStart = start + colId * 1440;
        let shiftEnd = end + colId * 1440;
        while (shiftEnd <= shiftStart) {
            shiftEnd = shiftEnd + 1440;
        }
        const updatedCycle = {
            data: {
                start: shiftStart,
                end: shiftEnd,
                duration: Math.abs(shiftEnd - shiftStart),
                positionId: data.position,
                localityId: data.localityId,
                idealSkill: data.idealSkill,
                pauses: data.pauses,
                overTime: data.overTime,
                standBy: data.standBy,
                agenda: data.agenda,
                note: data.note,
                pausesFixed: data.pausesFixed,
                customAttributes: data.customAttributes,
                period: data.period,
                id,
            },
            type: 'shift',
        };
        if (id === initialData?.shiftId) {
            try {
                await dispatch((0, update_cycle_detail_1.default)(updatedCycle));
            }
            catch (error) {
                await recoverAfterError(dispatch);
            }
        }
        else {
            try {
                await dispatch((0, set_cycle_detail_1.default)(updatedCycle));
            }
            catch (error) {
                await recoverAfterError(dispatch);
            }
        }
        try {
            await dispatch((0, set_cycle_detail_last_saved_1.default)(updatedCycle));
            await dispatch((0, ac_1.isLoading)(shift_context_1.SAVING_SHIFT_ACTION, true));
        }
        catch (error) {
            await recoverAfterError(dispatch);
        }
        return undefined;
    };
};
const isSaveLiveFunction = (formType, t) => (0, util_1.isDefined)(t) && formType === 'live';
exports.isSaveLiveFunction = isSaveLiveFunction;
const isSaveShiftTemplateFunction = (formType, t) => (0, util_1.isDefined)(t) && formType === 'shiftTemplate';
exports.isSaveShiftTemplateFunction = isSaveShiftTemplateFunction;
const isSaveTemplateFunction = (formType, t) => (0, util_1.isDefined)(t) && formType === 'template';
exports.isSaveTemplateFunction = isSaveTemplateFunction;
const isSaveCycleFunction = (formType, t) => (0, util_1.isDefined)(t) && formType === 'cycle';
exports.isSaveCycleFunction = isSaveCycleFunction;
const useSaveShiftMiddleware = ({ initialData, }) => {
    const dispatch = (0, store_1.useRootDispatch)();
    if (initialData?.type === 'live') {
        return saveLiveShift(initialData, dispatch);
    }
    if (initialData?.type === 'shiftTemplate') {
        return saveShiftTemplate(initialData, dispatch);
    }
    if (initialData?.type === 'template') {
        return saveTemplate(initialData, dispatch);
    }
    if (initialData?.type === 'cycle') {
        return saveCycle(initialData, dispatch);
    }
    return (async () => {
        react_hot_toast_1.default.custom(() => react_1.default.createElement(ui_1.Alert, {
            type: ui_1.Alert.TYPES.WARNING,
            text: `unhandled save method; type: ${initialData?.type ?? '-'}`,
        }));
        return undefined;
    });
};
exports.useSaveShiftMiddleware = useSaveShiftMiddleware;
